<template>
    <el-card class="box-card">
        <el-tabs v-model="activeName" @tab-click="tabClickChange">
            <el-tab-pane name="first" label="部落信息">
                <div class="component-content">
                    <section class="content">
                        <el-card>
                            <component-server :serverMode="'mode__one_game'" @oneGameServer="getGameValue"></component-server>
                            <el-form :inline="true" label-suffix=":">
                                <el-form-item label='酋长id'>
                                    <el-input v-model="tribeForm.uid" placeholder=''></el-input>
                                </el-form-item>
                                <el-form-item label='部落昵称'>
                                    <el-input v-model="tribeForm.tribeName" placeholder=''></el-input>
                                </el-form-item>
                                <el-form-item label='部落id'>
                                    <el-input v-model="tribeForm.tribeId" placeholder=''></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="tribeQuery">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>

                        <el-table :data="dataHandled" border     style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" label='部落id'>
                            </el-table-column>
                            <el-table-column prop="tribeName" label='部落昵称'>
                            </el-table-column>
                            <el-table-column prop="chairId" label='酋长id'>
                            </el-table-column>
                            <el-table-column prop="score" label='繁荣度'>
                            </el-table-column>
                            <el-table-column prop="resource" label='资源'>
                            </el-table-column>
                            <el-table-column prop="renameCard" label='改名卡数量'>
                            </el-table-column>
                            <el-table-column prop="createTime" :formatter="formatterTime" label='创建时间'>
                            </el-table-column>
                            <el-table-column label="操作" width="380px">
                                <template slot-scope="scope">
                                    <el-button type="success" @click="showTribeDetail(scope.row)">查看部落成员</el-button>
                                    <el-button type="success" @click="showClearTribeName(scope.row)">清除部落昵称</el-button>
                                    <el-button type="success" @click="showClearTribeBulletin(scope.row)">清除部落公告</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                                           layout="total, prev, pager, next, jumper" :total="totalRow">
                            </el-pagination>
                        </div>
                    </section>
                </div>

                <el-dialog title='部落成员' :visible.sync="tribeDetailShow" width="75%"
                           lock-scroll center>
                    <el-tabs tab-position="left" style="height: 100%;" @tab-click="handleTribeClick" v-model="tribeActiveName">
                        <el-tab-pane name="first" label="部落成员">
                            <el-card>
                                <el-table :data="tribeMemberData" border style="margin-top:20px;width: 100%">
                                    <el-table-column v-for="(header,index) in tribeHeader" :label="header.label"
                                                     :prop="header.text"
                                                     :key="index" width="150">
                                    </el-table-column>
                                </el-table>
                            </el-card>
                        </el-tab-pane>
                    </el-tabs>
                </el-dialog>

                <el-dialog title='清除部落昵称' :visible.sync="clearTribeNameShow" width="50%"
                           lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="言论标签">
                            <div class="opinion-tag">
                                <el-autocomplete
                                    class="inline-input"
                                    type="textarea"
                                    :maxlength="20"
                                    show-word-limit
                                    :autosize="{ minRows: 2}"
                                    v-model="clearTribeNameForm.chatLabelLv1"
                                    :fetch-suggestions="querySearchOpinionTagLv1"
                                    placeholder="请输入一级标签"
                                    @select="handleSelectOpinionTagLv1Rename"
                                >
                                    <template slot-scope="{ item }">
                                        <span class="addr">{{item.reason}}</span>
                                    </template>
                                </el-autocomplete>

                                <el-autocomplete
                                    class="inline-input"
                                    type="textarea"
                                    :maxlength="20"
                                    show-word-limit
                                    :autosize="{ minRows: 2}"
                                    v-model="clearTribeNameForm.chatLabelLv2"
                                    :fetch-suggestions="querySearchOpinionTagLv2"
                                    placeholder="请输入二级标签"
                                    @select="handleSelectOpinionTagLv2Rename"
                                >
                                    <template slot-scope="{ item }">
                                        <span class="addr">{{item.reason}}</span>
                                    </template>
                                </el-autocomplete>
                            </div>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="clearTribeNameShow = false">取消</el-button>
                        <el-button type="primary" @click="rewriteTribeName">确认</el-button>
                    </div>
                </el-dialog>

                <el-dialog title='清除部落公告' :visible.sync="clearTribeBulletinShow" width="50%"
                           lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="言论标签">
                            <div class="opinion-tag">
                                <el-autocomplete
                                    class="inline-input"
                                    type="textarea"
                                    :maxlength="20"
                                    show-word-limit
                                    :autosize="{ minRows: 2}"
                                    v-model="clearTribeBulletinForm.chatLabelLv1"
                                    :fetch-suggestions="querySearchOpinionTagLv1"
                                    placeholder="请输入一级标签"
                                    @select="handleSelectOpinionTagLv1Bulletin"
                                >
                                    <template slot-scope="{ item }">
                                        <span class="addr">{{item.reason}}</span>
                                    </template>
                                </el-autocomplete>

                                <el-autocomplete
                                    class="inline-input"
                                    type="textarea"
                                    :maxlength="20"
                                    show-word-limit
                                    :autosize="{ minRows: 2}"
                                    v-model="clearTribeBulletinForm.chatLabelLv2"
                                    :fetch-suggestions="querySearchOpinionTagLv2"
                                    placeholder="请输入二级标签"
                                    @select="handleSelectOpinionTagLv2Bulletin"
                                >
                                    <template slot-scope="{ item }">
                                        <span class="addr">{{item.reason}}</span>
                                    </template>
                                </el-autocomplete>
                            </div>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="clearTribeBulletinShow = false">取消</el-button>
                        <el-button type="primary" @click="rewriteTribeBulletin">确认</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>

            <el-tab-pane name="second" label="部落成员">
                <div class="component-content">
                    <section class="content">
                        <el-card>
                            <el-form :inline="true" label-suffix=":">
                                <el-form-item label='玩家id'>
                                    <el-input v-model="tribeForm.uid" placeholder=''></el-input>
                                </el-form-item>
                                <el-form-item label='部落昵称'>
                                    <el-input v-model="tribeForm.tribeName" placeholder=''></el-input>
                                </el-form-item>
                                <el-form-item label='部落id'>
                                    <el-input v-model="tribeForm.tribeId" placeholder=''></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>

                        <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                            <el-table-column prop="tribeId" label='成员id'>
                            </el-table-column>
                            <el-table-column prop="tribeName" label='成员昵称'>
                            </el-table-column>
                            <el-table-column prop="type" label='家族id'>
                            </el-table-column>
                            <el-table-column prop="monster_name" label='加入时间'>
                            </el-table-column>
                            <el-table-column prop="sid" label='成员职位'>
                            </el-table-column>
                            <el-table-column prop="monster_level" label='成员历史贡献'>
                            </el-table-column>
                            <el-table-column prop="monster_level" label='成员本周贡献'>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                                           layout="total, prev, pager, next, jumper" :total="totalRow">
                            </el-pagination>
                        </div>
                    </section>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';
    import gameApi from '../../service/game_api'
    import configSettingApi from '../../service/config_setting_api'
    import componentServer from '../../components/component_server'
    import Utils from '../../lib/utils'

    export default {
        name: "query_tribe",
        data () {
            return {
                tribeForm: {
                    uid: '',
                    tribeName: '',
                    tribeId: '',
                    serverId: '',
                    uri:''
                },
                activeName: 'first',

                tribeActiveName: 'first',
                tribeDetailShow: false,
                tribeMemberData: [],
                tribeHeader: [],

                clearTribeNameShow: false,
                clearTribeNameForm: {},

                clearTribeBulletinShow: false,
                clearTribeBulletinForm: {},

                // 言论标签数据
                opinionTagData: [],
                opinionTagDataLv1: [],
                opinionTagDataLv2: [],

                // 部落成员字段名
                tribeMemberHeaderOptions: [
                    {
                        value: 'id',
                        label: '玩家id'
                    },
                    {
                        value: 'server',
                        label: '游戏服编号'
                    },
                    {
                        value: 'position',
                        label: '职务'
                    },
                    {
                        value: 'joinTime',
                        label: '加入时间'
                    },
                    {
                        value: 'joinTribeWar',
                        label: '是否参加部落战'
                    },
                    {
                        value: 'warBufferType',
                        label: '战斗buff'
                    },
                    {
                        value: 'donationResource',
                        label: '贡献资源'
                    },
                    {
                        value: 'donationCurrent',
                        label: '当前贡献值'
                    },
                    {
                        value: 'donationTotal',
                        label: '总贡献值'
                    },
                    {
                        value: 'activityCurrent',
                        label: '活跃度'
                    }
                ]
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        mounted() {
          this.getOpinionTagListAll();
        },
        methods: {
            tabClickChange() {

            },
            handleTribeClick(tab) {
                // if(tab.name =='first'){
                // }
            },

            getGameValue(uri,serverId) {
                this.tribeForm.serverId = serverId;
                this.tribeForm.uri = uri;
                this.clearTribeNameForm.uri = uri;
                this.clearTribeNameForm.zoneId = serverId;
                this.clearTribeBulletinForm.uri = uri;
                this.clearTribeBulletinForm.zoneId = serverId;
            },

            // 部落查询
            tribeQuery() {
                gameApi.findTribes({
                    token: this.token,
                    tribeQueryBO: this.tribeForm
                }).then(res => {
                    this.dataHandled = res.content.tribes;
                })
            },

            formatterTime(row) {
                var createTime = row.createTime;
                createTime = Utils.formatDate(createTime);
                return createTime;
            },

            showTribeDetail(data) {
                this.tribeDetailShow = true;
                var memberMap = data.memberMap;
                this.tribeActiveName = 'first';
                for (var i in memberMap) {
                    this.tribeMemberData.push(memberMap[i])
                }

                for (var i in this.tribeMemberData[0]) {
                    this.tribeMemberHeaderOptions.forEach(item => {
                        if (i == item.value) {
                            this.tribeHeader.push({
                                text: i,
                                label: item.label
                            });
                        }
                    })
                }
            },

            // 清除部落昵称展示
            showClearTribeName(data) {
                this.clearTribeNameShow = true;
                this.clearTribeNameForm.tribeId = data.id;
            },

            // 清除部落公告展示
            showClearTribeBulletin(data) {
                this.clearTribeBulletinShow = true;
                this.clearTribeBulletinForm.tribeId = data.id;
            },

            // 模板列表查询
            getOpinionTagListAll() {
                configSettingApi.opinionTagList({
                    token: this.token
                }).then(res => {
                    this.opinionTagData = res;
                    this.opinionTagData.forEach(item => {
                        if (item.level == 1) {
                            this.opinionTagDataLv1.push(item);
                        } else if (item.level == 2) {
                            this.opinionTagDataLv2.push(item);
                        }
                    })
                })
            },

            querySearchOpinionTagLv1(queryString, cb) {
                var data = this.opinionTagDataLv1;
                var results = queryString ? data.filter(this.createFilterOpinionTag(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            querySearchOpinionTagLv2(queryString, cb) {
                var data = this.opinionTagDataLv2;
                var results = queryString ? data.filter(this.createFilterOpinionTag(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilterOpinionTag(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },

            handleSelectOpinionTagLv1Rename(item) {
                this.clearTribeNameForm.chatLabelLv1 = item.reason;
            },
            handleSelectOpinionTagLv2Rename(item) {
                this.clearTribeNameForm.chatLabelLv2 = item.reason;
            },

            handleSelectOpinionTagLv1Bulletin(item) {
                this.clearTribeBulletinForm.chatLabelLv1 = item.reason;
            },
            handleSelectOpinionTagLv2Bulletin(item) {
                this.clearTribeBulletinForm.chatLabelLv2 = item.reason;
            },

            // 清除部落昵称
            rewriteTribeName() {
                var data = this.clearTribeNameForm;
                gameApi.rewriteTribeName({
                    token: this.token,
                    clearTribeBO: {
                        uri: data.uri,
                        zoneId: data.zoneId,
                        tribeId: data.tribeId,
                        reason: data.chatLabelLv1 + '-' + data.chatLabelLv2
                    }
                }).then(res => {
                    this.clearTribeNameShow = false;
                    data.chatLabelLv1 ='';
                    data.chatLabelLv2 ='';
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    })
                })
            },

            // 清除部落公告
            rewriteTribeBulletin() {
                var data = this.clearTribeBulletinForm;
                gameApi.rewriteTribeBulletin({
                    token: this.token,
                    clearTribeBO: {
                        uri: data.uri,
                        zoneId: data.zoneId,
                        tribeId: data.tribeId,
                        reason: data.chatLabelLv1 + '-' + data.chatLabelLv2
                    }
                }).then(res => {
                    this.clearTribeBulletinShow = false;
                    data.chatLabelLv1 ='';
                    data.chatLabelLv2 ='';
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    })
                })
            }
        },
        components: {
            componentServer
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/players/query_tribe.vue